import React from "react";
import { Navigate } from "react-router-dom";
import { path } from "../Utils/ScreenPath";
import Layout from "../Layout/Layout";

const ProtectedRoute = ({ Component, allowedRoles = ["admin", "agent", "distributor"] }) => {
  const token = localStorage.getItem("token");
  const userRaw = localStorage.getItem("UserDetail");

  let user = null;
  try {
    user = userRaw ? JSON.parse(userRaw) : null;
  } catch (err) {
    console.error("Error parsing user detail from localStorage:", err);
  }
  

  const role = user?.role;

  if (!token || !role) {
    return <Navigate to={path.login} />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to={role == "admin" ? path.dashboardadmin : (role == "distributor" || role == "dealer") ? path.dashboard : path.dashboardagent} />;
  }

  return (
    <Layout>
      <Component />
    </Layout>
  );
};

export default ProtectedRoute;

